import React from 'react';
import classNameBind from 'classnames/bind';
import { getMonths } from '../../../../formatters';
import Popover from '../../../Popover';
import ActionList from '../../../ActionList';
import Button from '../../../Button';
import styles from './CaptionElement.module.css';

const bindClasses = classNameBind.bind(styles);

const CaptionElement = ({
  date,
  onChange,
  min,
  max,
  dataId,
  i18n,
  reportDatePickerLikeYearsRange,
} = {}) => {
  const yearSwitchStart = reportDatePickerLikeYearsRange ? 12 : 10;
  const monthNamesArr = getMonths(i18n.language);
  const months = [];
  const years = [];
  const currentYear = new Date().getFullYear() + (reportDatePickerLikeYearsRange ? 0 : 5);
  const compareMonthToBounds = (month, year) => (
    (year === max.getFullYear()
      && month > max.getMonth())
    || (year === min.getFullYear()
      && month < min.getMonth())
  );
  for (let i = 0; i < monthNamesArr.length; i += 1) {
    months.push({
      id: i,
      name: monthNamesArr[i],
      disabled: compareMonthToBounds(i, date.getFullYear()),
    });
  }
  for (let i = currentYear; i >= currentYear - yearSwitchStart; i -= 1) {
    if (!(i > max.getFullYear() || i < min.getFullYear())) {
      years.push({
        id: i,
        name: i.toString(),
      });
    }
  }

  const modifyMonth = (monthToSet) => {
    date.setMonth(monthToSet.id);
    onChange(date);
  };
  const modifyYear = (yearToSet) => {
    date.setFullYear(yearToSet.id);
    if (yearToSet.id === min.getFullYear()) {
      if (date.getMonth() < min.getMonth()) {
        date.setMonth(min.getMonth());
      }
    }
    if (yearToSet.id === max.getFullYear()) {
      if (date.getMonth() > max.getMonth()) {
        date.setMonth(max.getMonth());
      }
    }

    onChange(date);
  };

  const renderCaptionElement = (options, label, onItemSelected, id) => {
    const popoverProps = {
      position: 'bottom-end',
      openProps: {
        appearance: 'simple',
      },
      closedProps: {
        appearance: 'subdued',
      },
      activatorElement: (<Button text={label.toString()} iconRight="chevron-down" onClick={() => {}} fullWidth disabled={options.length < 2} />),
    };

    return (
      <div className={bindClasses('caption-el-wrapper')} data-ppuc-id={id}>
        <Popover
          {...popoverProps}
          childToggle={{ onItemSelected: option => option }}
          disabled={options.length < 2}
          dataId={`${id}.popover`}
        >
          <ActionList
            groups={[{ id: 1, items: options }]}
            onItemSelected={onItemSelected}
          />
        </Popover>
      </div>
    );
  };

  return (
    <div className={bindClasses('caption-wrapper')}>
      <div className={bindClasses('caption-inner')}>
        {renderCaptionElement(months, getMonths(i18n.language, 'short')[date.getMonth()], modifyMonth, `${dataId}.month`)}
        {renderCaptionElement(years, date.getFullYear(), modifyYear, `${dataId}.year`)}
      </div>
    </div>
  );
};

CaptionElement.defaultProps = {
  dataId: 'CaptionElement',
};

export default CaptionElement;
